export const firebaseConfig = {
  apiKey: "AIzaSyBklKThvY0TMw7WLjwqQXPs6IAzYK6RyZM",
  authDomain: "painguide-public.firebaseapp.com",
  databaseURL: "https://painguide-public.firebaseio.com",
  projectId: "painguide-public",
  storageBucket: "painguide-public.appspot.com",
  messagingSenderId: "815712303274"
};
